export default ({ request }) => ({
  mrpPendingGoodsInspectionOptionsApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/options',
      method: 'post',
      data,
    })
  },
  mrpPendingGoodsInspectionListApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/list',
      method: 'post',
      data,
    })
  },
  mrpPendingGoodsInspectionDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/detail',
      method: 'post',
      data,
    })
  },
  mrpPendingGoodsInspectionSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/save',
      method: 'post',
      data,
    })
  },
  mrpPendingGoodsInspectionDelApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/del',
      method: 'post',
      data,
    })
  },
  mrpPendingGoodsInspectionRecheckApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/recheck',
      method: 'post',
      data,
    })
  },
  mrpPendingGoodsInspectionSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/inspection/submit',
      method: 'post',
      data,
    })
  },
})
